@if (!isEditing) {
  <div class="content" [ngClass]="{'editable': !readonly}" (click)="enableEditing(); $event.stopPropagation();">
    @if (!content) {
      <div class="no-content">
        {{placeholder !== undefined ? placeholder : 'Click to edit...'}}
      </div>
    }
    @else if (!!content && renderHtml) {
      <div class="the-content" [innerHTML]="content"></div>
    } @else {
      <div class="the-content" [textContent]="content"></div>
    }
  </div>
}
@if (isEditing) {
  <input pInputText [size]="size" #contentInput class="form-input content-edit" autocomplete="off" (keydown.enter)="save()" (click)="$event.stopPropagation()" [(ngModel)]="content">
}
@if (isEditing) {
  <div class="actions">
    <p-button type="button" icon="true" (click)="save(); $event.stopPropagation()"><fa-icon [icon]="saveIcon"></fa-icon></p-button>
    <p-button type="button" icon="true" styleClass="p-button-text" (click)="cancel(); $event.stopPropagation();"><fa-icon [icon]="faTimes"></fa-icon></p-button>
  </div>
}
